import getConfigValue from '@/config';
import { Turnstile, TurnstileInstance } from '@marsidev/react-turnstile';
import { forwardRef } from 'react';

interface TurnstileWidgetProps {
  onSuccess: (token: string) => void;
  onExpire: () => void;
  onError: () => void;
}

const siteKey = getConfigValue('VITE_APP_TURNSTILE_SITE_KEY') || '';

export const TurnstileWidget = forwardRef<TurnstileInstance | undefined, TurnstileWidgetProps>(
  ({ onSuccess, onExpire, onError }, ref) => {
    return (
      <Turnstile
        ref={ref}
        siteKey={siteKey}
        onSuccess={onSuccess}
        onExpire={onExpire}
        onError={onError}
        options={{ theme: 'light' }}
      />
    );
  },
);
